import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Team, TeamMember, PageResponse } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class TeamService {
  private readonly apiUrl = `${environment.apiUrl}/teams`;

  constructor(private http: HttpClient) {}

  getTeams(search = '', page = 0, size = 10, sort = 'name,asc', showArchived = false): Observable<PageResponse<Team>> {
    const params = new HttpParams()
      .set('search', search)
      .set('page', String(page))
      .set('size', String(size))
      .set('sort', sort)
      .set('showArchived', String(showArchived));

    return this.http.get<PageResponse<Team>>(this.apiUrl, { params });
  }

  getTeamById(id: number): Observable<Team> {
    return this.http.get<Team>(`${this.apiUrl}/${id}`);
  }

  createTeam(team: Team): Observable<Team> {
    return this.http.post<Team>(this.apiUrl, team);
  }

  updateTeam(id: number, team: Team): Observable<Team> {
    return this.http.put<Team>(`${this.apiUrl}/${id}`, team);
  }

  deleteTeam(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  canDeleteTeam(id: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/${id}/can-delete`);
  }

  getTeamMembers(teamId: number, search = '', page = 0, size = 10): Observable<PageResponse<TeamMember>> {
    const params = new HttpParams()
      .set('search', search)
      .set('page', String(page))
      .set('size', String(size));
    return this.http.get<PageResponse<TeamMember>>(`${this.apiUrl}/${teamId}/members`, { params });
  }

  getTeamCandidates(teamId: number, search = '', page = 0, size = 10): Observable<PageResponse<TeamMember>> {
    const params = new HttpParams()
      .set('search', search)
      .set('page', String(page))
      .set('size', String(size));
    return this.http.get<PageResponse<TeamMember>>(`${this.apiUrl}/${teamId}/candidates`, { params });
  }

  addMembers(teamId: number, userIds: number[]): Observable<TeamMember[]> {
    return this.http.post<TeamMember[]>(`${this.apiUrl}/${teamId}/members`, { userIds });
  }

  removeMember(teamId: number, userId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${teamId}/members/${userId}`);
  }
}
